export const questionnaireKeys = {
  questionnaire: () => ['questionnaire'],
}
